import http from "./http";

export type ConsentType = "customer_tc" | "station_agreement" | "station_view_only";

export type AdminConsentLogRecord = {
	id: number;
	consentType: ConsentType;
	userId: number | null;
	partnerId: number | null;
	orderId: number | null;
	email: string | null;
	documentKey: string;
	documentVersion: number | null;
	documentVersionLabel?: string | null;
	ipAddress: string | null;
	userAgent: string | null;
	agreedAt: string;
	createdAt: string;
	partner?: {
		id: number;
		name?: string | null;
		displayName?: string | null;
	} | null;
};

export type GetAdminConsentLogsParams = {
	consentType?: ConsentType | "";
	partnerId?: string;
	orderId?: string;
	fromDate?: string;
	toDate?: string;
	documentKey?: string;
	page?: number;
	limit?: number;
};

export async function getAdminConsentLogs(params: GetAdminConsentLogsParams = {}): Promise<{
	data: AdminConsentLogRecord[];
	total: number;
	page: number;
	limit: number;
}> {
	const { data } = await http.get("/admin/consent-logs", { params });
	return {
		data: (data?.data || []) as AdminConsentLogRecord[],
		total: data?.total || 0,
		page: data?.page || 1,
		limit: data?.limit || params.limit || 20,
	};
}

export function buildExportUrl(params: GetAdminConsentLogsParams = {}): string {
	const query = new URLSearchParams();
	if (params.consentType) query.set("consentType", params.consentType);
	if (params.partnerId) query.set("partnerId", params.partnerId);
	if (params.orderId) query.set("orderId", params.orderId);
	if (params.fromDate) query.set("fromDate", params.fromDate);
	if (params.toDate) query.set("toDate", params.toDate);
	if (params.documentKey) query.set("documentKey", params.documentKey);
	query.set("limit", "10000");
	return `/admin/consent-logs/export?${query.toString()}`;
}
